/* eslint-disable jsx-a11y/anchor-is-valid */
import {useState, useEffect} from 'react'
import {useParams} from 'react-router-dom'
import axios from 'axios'
import apiConnect from '../../../api/apiConnect'

const DataRecorded = ({deviceData}) => {
  const deviceId = useParams().deviceId
  const [parameterLists, setParameterLists] = useState([])
  const [selectedParameterId, setSelectedParameterId] = useState(null)
  const [firstDataTime, setFirstDataTime] = useState(null)
  const [lastDataTime, setLastDataTime] = useState(null)

  useEffect(() => {
    async function fetchData() {
      try {
        const response = await apiConnect.get(`/v1/parameters/by-device-id/${deviceId}`)
        const parameters = response.data.data
        setParameterLists(parameters)

        if (parameters.length > 0) {
          setSelectedParameterId(parameters[0].id)
        }
      } catch (error) {
        console.error('Error fetching data:', error)
      }
    }
    if (deviceId !== undefined) {
      fetchData()
    }
  }, [])

  // Load time data for selected parameter
  useEffect(() => {
    async function fetchDataTime() {
      if (!selectedParameterId) return

      try {
        const response = await apiConnect.get(
          `/v1/parameters/${selectedParameterId}/first-last-data`
        )

        const {first, last} = response.data.data
        setFirstDataTime(getTimeFormat(first))
        setLastDataTime(getTimeFormat(last))
      } catch (error) {
        console.error('Error fetching data time:', error)
      }
    }

    fetchDataTime()
  }, [selectedParameterId])

  const handleParameterChange = (e) => {
    setSelectedParameterId(e.target.value)
  }

  return (
    <>
      <div className='mb-5'>
        <div className='row mb-5'>
          <div className='col-12'>
            <div className='row mb-5'>
              <label className='col-lg-4 fw-bold text-muted'>Parameter</label>
              <div className='col-lg-8'>
                <select
                  className='form-select'
                  value={selectedParameterId || ''}
                  onChange={handleParameterChange}
                >
                  {parameterLists.map((parameter) => (
                    <option key={parameter.id} value={parameter.id}>
                      {parameter.name}
                    </option>
                  ))}
                </select>
              </div>
            </div>

            <div className='row mb-5'>
              <label className='col-lg-4 fw-bold text-muted'>First Data Time</label>
              <div className='col-lg-8'>
                <span className='fw-bolder fs-6 text-dark'>{firstDataTime}</span>
              </div>
            </div>

            <div className='row'>
              <label className='col-lg-4 fw-bold text-muted'>Last Data Time</label>
              <div className='col-lg-8'>
                <span className='fw-bolder fs-6 text-dark'>{lastDataTime}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export {DataRecorded}

function getTimeFormat(timestamp) {
  const createdAt = new Date(timestamp * 1000)
  const formattedDate = createdAt.toLocaleDateString('en-GB', {
    day: '2-digit',
    month: 'short',
    year: 'numeric',
  })
  const formattedTime = createdAt.toLocaleTimeString('en-GB', {
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
  })
  const formattedDateTime = `${formattedDate} ${formattedTime}`
  return formattedDateTime
}
